export const BetaFeatures = {
  LOGIN_ELEVATED_RAVEN: 'LOGIN_ELEVATED_RAVEN',
  SSO_ELEVATED_LOGIN: 'SSO_ELEVATED_LOGIN',
};
